import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getEnabledVerificationProjects } from "@/services/api";

export interface SelectOption<T = number> {
  value: T;
  label: string;
}

export const sharedVerificationKeys = {
  all: ["verifications-shared"] as const,
  enabledProjects: (classificationId?: number | null) =>
    [
      ...sharedVerificationKeys.all,
      "enabledProjects",
      classificationId,
    ] as const,
};

// Query hook for fetching enabled verification projects
export const useEnabledProjectsQuery = (classificationId?: number | null) => {
  return useQuery<SelectOption[]>({
    queryKey: sharedVerificationKeys.enabledProjects(classificationId),
    queryFn: () => getEnabledVerificationProjects(classificationId),
    ...reactQueryCacheAndRefetchOptions,
  });
};
